import React, { useState } from 'react';

import { Collapse, Tabs } from 'antd';
import ProjectDetails from './projectDetails/ProjectDetails';
import './projectDetails/projectDetails.css';
import IPSProjectChecklist from './projectChecklist/ipsprojectchecklist';
import './projectDetails/projectDetails.css';
import Team from './TeamSection/Team';
import IPSScheduling from './projectSchedule/ipsschedule';
import { updateIpsDTProjectDetail } from 'api';
import { isIPSDataCreatorOrAdministrator } from 'utils/UserInfo';
import AddOrRemovePhaseSection from './AddNewPhaseSection';

const { Panel } = Collapse;
const { TabPane } = Tabs;
function DataTrackerTabContainer({
  project,
  status,
  history,
  context,
  teamMembers,
  // allComments,
  allDropDownOptions,
  setCurrentProject
}) {
  

  const { ipsProjectDetails } = project;

  // comment State
  const [commonComments, setCommonComments] = useState(
    project.dataTrackerComments.filter(
      (everyComment) => everyComment.commentGrp === 'COMMON'
    )
  );
  const handleProjectDetailUpdate = async (
    value,
    fieldName,
    dataType,
    phaseId,
    statusAction,
    auditId
  ) => {
    let field = {};
    field['bpid'] = project.bpid;
    field['workOrder'] = project.workOrder;
    field['stationName'] = project.stationName;
    field['dataField'] = fieldName;
    field['phase'] = phaseId;
    field['statusAction'] = statusAction===null? 'A':statusAction;
    field['auditId'] = auditId;

    if (dataType === 'string') {
      field['charValue'] = value;
    } else if (dataType === 'number') {
      field['numValue'] = value;
    } else if (dataType === 'date') {
      field['dateValue'] = value;
    }
    const response = await updateIpsDTProjectDetail(field);

    // checking if response value is present incase of failure it keep last state value instead of update project value with empty array
    if (response?.bpid) {
      
      setCurrentProject(response)
    }
    // we are only using response in ipsWorkComplete Section for redirecting user
    return response;
  };

  const [isReadOnly, setReadOnly] = useState(
    project?.allIPSComplFlag === 'Y' ||
      !isIPSDataCreatorOrAdministrator()
  );

  const isItLastPhase = () => {
    return (
      ipsProjectDetails.filter((everyPhase) => everyPhase.ipsComplFlag === 'N')
        .length === 1
    );
  };

  return (
    <Collapse
      defaultActiveKey={['1']}
      className='site-collapse-custom-collapse'
      destroyInactivePanel
    >
      <Panel
        header='Project Details'
        key='1'
        className='site-collapse-custom-panel'
      >
        <ProjectDetails
          project={project}
         
          handleProjectDetailUpdate={handleProjectDetailUpdate}
          
          commonComments={commonComments}
          history={history}
          context={context}
          isReadOnly={isReadOnly}
        />
      </Panel>
      <Panel header='Team' key='2' className='site-collapse-custom-panel'>
        <Team
          project={project}
          status={status}
          history={history}
          teamMembers={teamMembers}
        />
      </Panel>

      {ipsProjectDetails.length === 1 ? (
        <>
          <Panel
            header='Scheduling'
            key='3'
            className='site-collapse-custom-panel'
            extra={
              <AddOrRemovePhaseSection
                project={project}
               
                phaseDetails={ipsProjectDetails[0]}
                phaseId={ipsProjectDetails[0].id.phase}
                ipsProjectDetails={ipsProjectDetails}
               
                setCurrentProject={setCurrentProject}
              />
            }
          >
            <IPSScheduling
              project={project}
              
              phaseDetails={ipsProjectDetails[0]}
              phaseId={ipsProjectDetails[0].id.phase}
              allDropDownOptions={allDropDownOptions}
              handleProjectDetailUpdate={handleProjectDetailUpdate}
              isReadOnly={isReadOnly}
            />
          </Panel>
          <Panel
            header='Checklist'
            key='4'
            // className='site-collapse-custom-panel'
          >
            <IPSProjectChecklist
              project={project}
              history={history}
              context={context}
              allComments={ipsProjectDetails[0].dataTrackerComments}
              phaseDetails={ipsProjectDetails[0]}
              phaseId={ipsProjectDetails[0].id.phase}
              allDropDownOptions={allDropDownOptions}
              handleProjectDetailUpdate={handleProjectDetailUpdate}
              isReadOnly={isReadOnly}
              isItLastPhase={isItLastPhase()}
            />
          </Panel>
        </>
      ) : (
        <>
          <section
            className='pt-3'
            style={{
              border: ' 0.5px 0px 0.5px 0px solid black',
              backgroundColor: 'white',
            }}
          >
            <Tabs type='card' destroyInactiveTabPane>
              {ipsProjectDetails.map((everyPhase, index) => {
                return (
                  <TabPane
                    tab={`Phase ${index + 1}`}
                    key={`${everyPhase.id.phase}`}
                  >
                    <>
                      <Collapse
                        className='site-collapse-custom-collapse'
                        destroyInactivePanel
                      >
                        <Panel
                          header='Scheduling'
                          key='3'
                          className='site-collapse-custom-panel'
                          extra={
                            <AddOrRemovePhaseSection
                              project={project}
                              
                              phaseDetails={everyPhase}
                              phaseId={everyPhase.id.phase}
                              ipsProjectDetails={ipsProjectDetails}
                              
                              setCurrentProject={setCurrentProject}
                            />
                          }
                        >
                          <IPSScheduling
                            project={project}
                            
                            phaseDetails={everyPhase}
                            phaseId={everyPhase.id.phase}
                            allDropDownOptions={allDropDownOptions}
                            handleProjectDetailUpdate={
                              handleProjectDetailUpdate
                            }
                            isReadOnly={isReadOnly}
                          />
                        </Panel>
                        <Panel header='Checklist' key='4'>
                          <IPSProjectChecklist
                            project={project}
                            phaseDetails={everyPhase}
                            phaseId={everyPhase.id.phase}
                            history={history}
                            context={context}
                            allComments={everyPhase.dataTrackerComments}
                            allDropDownOptions={allDropDownOptions}
                            handleProjectDetailUpdate={
                              handleProjectDetailUpdate
                            }
                            isReadOnly={isReadOnly}
                            isItLastPhase={isItLastPhase()}
                          />
                        </Panel>
                      </Collapse>
                    </>
                  </TabPane>
                );
              })}
            </Tabs>
          </section>
        </>
      )}
    </Collapse>
  );
}

export default DataTrackerTabContainer;
